import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';
import { MailApi } from '~/api';

var actions = {
	sendAffiliationCompletedMail: function () {
		var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
			var to = _ref.to,
			    name = _ref.name,
			    email = _ref.email,
			    link = _ref.link;
			return _regeneratorRuntime.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							_context.next = 2;
							return new MailApi(this.$axios).sendAffiliationCompletedMail({
								to: to,
								name: name,
								email: email,
								link: link
							});

						case 2:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, this);
		}));

		function sendAffiliationCompletedMail(_x) {
			return _ref2.apply(this, arguments);
		}

		return sendAffiliationCompletedMail;
	}(),
	sendSuccesfullyCreatedUserMail: function () {
		var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
			var to = _ref3.to,
			    name = _ref3.name,
			    email = _ref3.email;
			return _regeneratorRuntime.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							_context2.next = 2;
							return new MailApi(this.$axios).sendSuccesfullyCreatedUserMail({
								to: to,
								name: name,
								email: email
							});

						case 2:
						case 'end':
							return _context2.stop();
					}
				}
			}, _callee2, this);
		}));

		function sendSuccesfullyCreatedUserMail(_x2) {
			return _ref4.apply(this, arguments);
		}

		return sendSuccesfullyCreatedUserMail;
	}()
};


//////////////////
// WEBPACK FOOTER
// ./src/store/mailing.js
// module id = ./src/store/mailing.js
// module chunks = 34